var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"banner",staticStyle:{"position":"relative","width":"100%"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/img/makecloud.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"register-btn",on:{"click":function($event){_vm.register('make')}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233041bd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/makecloud/makecloud.vue
// module id = null
// module chunks = 